// extracted by mini-css-extract-plugin
export var pillWrapper = "_yn-0";
export var showOverflow = "_yn-1";